export const compareAndAssignState = (val1, val2) => {
  if (val1 > val2) {
    return "positive";
  } else if (val1 === val2) {
    return "neutral";
  } else {
    return "negative";
  }
};

export const assignState = (val) => {
  if (Number(val) > 0) {
    return "positive";
  } else if (Number(val) === 0) {
    return "neutral";
  } else {
    return "negative";
  }
};

export const assignValByCondition = (val, okay, good) => {
  if (Number(val) >= good) {
    return "positive";
  } else if (Number(val) >= okay) {
    return "neutral";
  } else {
    return "negative";
  }
};

export const formatValue = (format, value) => {
  let output;
  if (!isNaN(value)) {
    switch (format) {
      case "percentage":
        return Math.floor(value * 100) / 100 + "%";
      case "percentage_signed":
        const rounded = Math.floor(value * 100) / 100;
        return (rounded > 0 ? "+" : "") + rounded + "%";
      case "percentage_decimals_2":
        return (Math.floor(value * 100) / 100).toFixed(2) + "%";
      case "percentage_decimals_0":
        return Math.floor(value) + "%";
      case "number":
        return Number(value).toLocaleString();
      case "money":
        if (Number(value) < 0) {
          return Number(Math.round(value)).toLocaleString();
        } else {
          return "$" + Number(Math.round(value)).toLocaleString();
        }
      case "money_dollarIncludedAlways":
        if (Number(value) < 0) {
          output = Number(Math.round(value)).toLocaleString();
          output = "-$" + output.slice(1);
          return output;
        } else {
          return "$" + Number(Math.round(value)).toLocaleString();
        }
      case "millions":
        // output = Number(Math.round(value)).toLocaleString();
        output = Math.abs(Number(value)) / 1.0e6;
        return "$" + Math.round(output).toLocaleString() + "M";
      case "stringToMill":
        return "$" + value + "M";
      case "decimal_1":
        return Math.round(Number(value) * 10) / 10;
      case "decimal_2":
        return Math.round(Number(value) * 100) / 100;
      case "orphan_score":
        output = Math.round(Number(value) * 100) / 10;
        return output.toFixed(1);
    }
  } else if (format === "capitalize") {
    return value.toUpperCase();
  } else {
    return 0;
  }
};

export const calcTotal = (column, data) => {
  let total = 0;
  data.map((x) => (total = total + Number(x[column])));
  return total;
};

export const varianceStorage = (storingObj, valCur, valPast, column, index) => {
  let value = Number(valCur) - Number(valPast);
  let totalVal = !isNaN(storingObj[column])
    ? Number(storingObj[column]) + value
    : value;
  storingObj[column] = totalVal;
  return value;
};

export const calcVarTotal = (data, colTargetting) => {
  let total = !isNaN(data[colTargetting]) ? Number(data[colTargetting]) : 0;
  return total;
};

export const classRendering = (val, okayCriteria, goodCriteria, type) => {
  let status = assignValByCondition(Number(val), okayCriteria, goodCriteria);
  let classes;
  if (type === "cell") {
    classes = {
      negative: "cell-red",
      neutral: "cell-yellow",
      positive: "cell-green",
    };
  } else if (type === "text") {
    classes = {
      negative: "red",
      neutral: "yellow",
      positive: "green",
    };
  }
  let output =
    typeof classes[status] !== "undefined" ? classes[status] : "cell-red";
  return output;
};

export const arrayToString = (array) => {
  let output = array.toString();
  output = output.replace(/,/g, ", ");
  return output;
};

export const splitFirstAndLastName = (fullName) => {
  let names = [];
  let spaceLocation = fullName.indexOf(" ");
  names.push(fullName.substring(0, spaceLocation));
  names.push(fullName.substring(spaceLocation + 1));
  return names;
};

export const capitalizeTitle = (string) => {
  console.warn("sting capitalizing is: " + string);
  let initial = string.substring(0, 1).toUpperCase();
  let title = string.substring(1);
  return initial + title;
};

export const addSpaceAfterComma = (string) => {
  let formatted = string.replace(/,/g, ", ");
  return formatted;
};

export const camelize = (str) => {
  return str
    .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    })
    .replace(/\s+/g, "");
};

export const swapUnderlineWithSpace = (string) => {
  let formatted = string.replace(/_/g, " ");
  return formatted;
};

export const formatUrl = (string) => {
  console.warn("url is: " + string);
  let formatted = string.substring(1, string.lastIndexOf("/"));
  console.warn(formatted);
  formatted = formatted.replace(/-/g, " ");
  formatted =
    capitalizeTitle(formatted.substring(0, formatted.lastIndexOf(" "))) +
    " " +
    capitalizeTitle(formatted.substring(formatted.lastIndexOf(" ") + 1));
  console.warn(formatted);
  return formatted;
};

export const dbDateFormat = (db_date) => {
  const date = getDateFormat(new Date(db_date));
  const curDate = getDateFormat(new Date());
  let output;
  if (
    date.year === curDate.year &&
    date.month === curDate.month &&
    date.date === curDate.date
  ) {
    output = date.hour + ":" + date.minute + " " + date.amPm;
  } else if (
    date.year === curDate.year &&
    date.month === curDate.month &&
    date.date > curDate.date - 7
  ) {
    output = date.day + " " + date.hour + ":" + date.minute + " " + date.amPm;
  } else if (date.year === curDate.year) {
    output = date.monthDays + " " + date.date + date.dateEndLetters;
  } else {
    output = date.date + "/" + date.month + "/" + date.year;
  }
  return output;
};

export const getTargetFieldOfDate = (db_date, returnRequested) => {
  const date = getDateFormat(new Date(db_date));
  switch (returnRequested) {
    case "Year":
      return date.year;
    case "Month":
      return date.month;
    case "MonthName":
      return date.monthDays;
    case "Date":
      return date.date;
    case "Day":
      return date.day;
    case "DayWithLetters":
      return date.dateEndLetters;
  }
};

export const stringDateFormat = (str_date) => {
  const yr = str_date.substring(str_date.lastIndexOf("/") + 1, str_date.length);
  const mnth = str_date.substring(
    str_date.indexOf("/") + 1,
    str_date.lastIndexOf("/")
  );
  const day = str_date.substring(0, str_date.indexOf("/"));
  console.log(yr);
  console.log(mnth);
  console.log(day);
  const date = getDateFormat(new Date(yr, mnth, day));
  const curDate = getDateFormat(new Date());
  let output;
  if (
    date.year === curDate.year &&
    date.month === curDate.month &&
    date.date === curDate.date
  ) {
    output = date.hour + ":" + date.minute + " " + date.amPm;
  } else if (
    date.year === curDate.year &&
    date.month === curDate.month &&
    date.date > curDate.date - 7
  ) {
    output = date.day + " " + date.hour + ":" + date.minute + " " + date.amPm;
  } else if (date.year === curDate.year) {
    output = date.monthDays + " " + date.date + date.dateEndLetters;
  } else {
    output = date.date + "/" + date.month + "/" + date.year;
  }
  return output;
};

export const getDateFormat = (date) => {
  const dayNames = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const dateObj = {
    year: date.getFullYear(),
    month: date.getMonth() + 1,
    monthDays: monthNames[date.getMonth()],
    date: date.getDate(),
    hour: date.getHours() > 12 ? date.getHours() - 12 : date.getHours(),
    minute:
      date.getMinutes().toString().length > 1
        ? date.getMinutes()
        : "0" + date.getMinutes().toString(),
    day: dayNames[date.getDay() - 1],
    amPm: date.getHours() <= 12 ? "AM" : "PM",
    dateEndLetters: assignEndLettersDate(date.getDate()),
  };
  return dateObj;
};

export const assignEndLettersDate = (date) => {
  let allLetterOptions = [
    { letters: "st", num: [1, 21, 31] },
    { letters: "nd", num: [2, 22] },
    { letters: "rd", num: [3, 23] },
    {
      letters: "th",
      num: [
        4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 24, 25,
        26, 27, 28, 29, 30,
      ],
    },
  ];
  for (var i = 0; i < allLetterOptions.length; i++) {
    if (allLetterOptions[i].num.includes(date)) {
      return allLetterOptions[i].letters;
    }
  }
};

export const shortNumber = (number) => {
  let output = Math.floor(parseInt(number) / 100000) / 10;
  if (output < 1 && number != 0) {
    output = Math.floor(parseInt(number) / 100) / 10;
    output = "$" + output + "K";
  } else if (number == 0) {
    return "-";
  } else {
    output = "$" + output + "M";
  }
  return output;
};

export const formatDateRange = (start, end) => {
  const startDateObj = getDateFormat(new Date(start));
  const endDateObj = getDateFormat(new Date(end));
  // console.group('Date formatting');
  // console.table(startDateObj);
  // console.table(endDateObj);
  let startOutput;
  // if(startDateObj.year === endDateObj.year){
  //   if(startDateObj.month === endDateObj.month){
  //     startOutput = startDateObj.date;
  //   }else{
  //     startOutput =startDateObj.date+"/"+startDateObj.month;
  //   }
  // }else{
  startOutput =
    startDateObj.date + "/" + startDateObj.month + "/" + startDateObj.year;
  // }
  // console.log(startOutput);
  let endOutput =
    endDateObj.date + "/" + endDateObj.month + "/" + endDateObj.year;
  // console.log(endOutput);
  // console.groupEnd();
  return startOutput + " - " + endOutput;
};

export const formatDataToString = (data) => {
  let formatted = "";
  if (typeof data === "string") {
    formatted = data.replace(/'/g, "");
    formatted = formatted.replace(/,/g, ", ");
  } else {
    for (var i = 0; i < data.length; i++) {
      if (i + 1 === data.length) {
        formatted += data[i];
      } else {
        formatted += data[i] + ", ";
      }
    }
  }

  return formatted;
};

export const shortenData = (data, type, maxCharCount) => {
  data = typeof data !== "undefined" && data !== null ? data.replaceAll("null", "") : data;
  if (typeof data !== "undefined" && data !== null && data.trim().length > 0) {
    let output =
      data.length > Number(maxCharCount)
        ? data.substring(0, Number(maxCharCount)) + "..."
        : data;
    return output;
  } else {
    if (type === "client") {
      return "Name Unknown";
    } else if (type === "address") {
      return "Address Unknown";
    } else if (type === "office") {
      return "Office Unknown";
    } else if (type === "suburb") {
      return "Suburb Unknown";
    } else {
      return "Undefined";
    }
  }
};

export const abbreviate = (val) => {
  const output = val
    .match(/\b([A-Za-z0-9])/g)
    .join("")
    .toUpperCase();
  return output;
};

export const dateFormat = (data, format) => {
  let formatted = data;
  let dateObj = getDateFormat(new Date(data));
  if (format === "DD-MM-YYYY") {
    formatted = dateObj.date + "/" + dateObj.month + "/" + dateObj.year;
  }
  return formatted;
};

export const calcPercentage = (total, val) => {
  const onePerc = Number(total) / 100;
  const percOfTotal = Number(val) / onePerc;
  return formatValue("percentage", percOfTotal);
};

export const calcSum = (data, key) => {
  let sum = 0;
  data.forEach(addTogether);

  function addTogether(item) {
    sum += Number(item[key]);
  }
  return sum;
};

export const splitValOnComma = (data) => {
  if (data.includes(",")) {
    const vals = data.split(",");
    return vals;
  } else {
    return 0;
  }
};

export const stringDateToSupportedJsTime = (stringDate) => {
  let output =
    stringDate.substring(stringDate.lastIndexOf("/"), stringDate.length) +
    "-" +
    stringDate.substring(stringDate.indexOf("/"), stringDate.lastIndexOf("/")) +
    "-" +
    stringDate.substring(0, stringDate.indexOf("/"));
  return new Date(output).getTime();
};

export const formatVendorDash = (n, formatTo) => {
  // { list }: { list: User[] }
  let output = n;
  if (formatTo === "numString") {
    output = Number(n).toLocaleString();
  } else if (formatTo === "perc") {
    output = n.toString() + "%";
  } else if (formatTo === "perc_1d") {
    output = Number(n).toFixed(1);
    output = output.toString() + "%";
  } else if (formatTo === "perc_2d") {
    output = Number(n).toFixed(2);
    output = output.toString() + "%";
  }
  return output;
};
